import { render, staticRenderFns } from "./FaultTypes.vue?vue&type=template&id=b1028f4e"
import script from "./FaultTypes.vue?vue&type=script&lang=ts"
export * from "./FaultTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports